import './webpack';
import * as bundle from 'bundle';

if (Playtech.Variables.isGameWrapper) {
    bundle.renderApp({ container: document.querySelector('#wrapper'), isWrapper: true });
} else {
    require('./app.js');
}
